import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CredentialsDtoLOGIN, LoginDto, UserDto } from '@dto';
import { GenericOldService } from './generic-old.service';
import { UserService } from './user.service';

@Injectable()
export class LoginService {
  API_ENDPOINT = 'login';

  constructor(
    private resourceService: GenericOldService<CredentialsDtoLOGIN>,
    private userService: UserService,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  login(credentials: CredentialsDtoLOGIN): Observable<LoginDto> {
    if (!credentials.username || !credentials.password) {
      return of(null);
    }
    return this.resourceService.post(this.API_ENDPOINT, credentials) as unknown as Observable<LoginDto>;
  }

  redirect() {
    const urlParams = new URLSearchParams(window.location.search);
    this.document.location.href = urlParams.get('redirect_url');
  }

  hasRedirect() {
    const urlParams = new URLSearchParams(window.location.search);
    return !!urlParams.get('redirect_url');
  }

  handleLogin(): Observable<UserDto> {
    // @ts-ignore
    return this.userService.getUserDetails().pipe(
      // We need to catch the error here and not in the interceptor to prevent the subsequent applications call
      catchError(error => {
        console.error('Error caught logging in: ', error);
        // Return a new observable to continue the stream
        return error; // Or handle the error in another way
      }),
    );
  }
}
